export default __webpack_public_path__ + "static/adam-749a13121fa74238f2949db2f8c993b8.jpg";